import React from "react";
import { useObjectStore } from "../zustand/objects";

import { ColorInput } from '@mantine/core';

const TextObjectBackgroundColourButton = ({ bGColour, id, uiTheme }) => {

  const swatchColours = [' ','#000000', '#C4A484', '#00FFFF', '#359DED', '#77D356', '#C0C0C0', '#808080', '#FFA500', '#CD303E', '#FF00FF', '#FAC710', '#FFFFFF']

  const { arrangeUndoRedo, updateTextBackgroundColour, currentObjectArtboard } = useObjectStore();
  const borderColour = uiTheme?.borderColour || "#E5E7EB";
  const iconColour = uiTheme?.iconColour || "#6A7282";
  const textColour = uiTheme?.textColour || "#111827";
  const placeholderColour = uiTheme?.placeholderColour || "#6A7282";

  const handleSelect = (mapped) => {
    // send current state to undoActions
    mapped && arrangeUndoRedo({
      updateType: "objectUpdate",
      artboard: currentObjectArtboard,
      objectID: id,
      undo: false,
      field: "bGColour"
    })
    // send update to zustand
    mapped && updateTextBackgroundColour({
      id: id,
      currentObjectArtboard: currentObjectArtboard,
      bGColour: mapped,
      undo: false
    })
  }

  return (

    // <div style={{ inline: true, height:38, marginBottom:8, marginTop:8, fontSize: 12, width:90,  display:'flex', transition: "width 0.2s", justifyContent: 'flex-start' }}>
      <ColorInput
      placeholder="Colour"
      defaultValue={bGColour}
      onChange={(e) => handleSelect(e)}
      label="Background"
      size="sm"
      // radius={32}
      disallowInput
      withPicker={false}
      withEyeDropper={false}
      swatches={[...swatchColours]}
      swatchesPerRow={4}
      styles={{
        label: { color: textColour, fontWeight: 600 },
        input: {
          color: textColour,
          borderColor: borderColour,
          "&:focus": { borderColor: borderColour },
          "&:focus-within": { borderColor: borderColour },
        },
        section: { color: iconColour },
        placeholder: { color: placeholderColour },
      }}
    />
    // </div>


  );
};

export default TextObjectBackgroundColourButton;